/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Filter_ApplyInputs */

const vi_common_filter_apply = /** @type {(inputs: Common_Filter_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áp dụng`)
};

/**

* @param {Common_Filter_ApplyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_filter_apply = /** @type {((inputs?: Common_Filter_ApplyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Filter_ApplyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_filter_apply(inputs)
});